define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/common"], function (require, exports, $, ko, log, urls_1, tools, Common) {
    "use strict";
    var Register = /** @class */ (function () {
        function Register() {
            this.Email = ko.observable();
            this.Password = ko.observable();
            this.ConfirmPassword = ko.observable();
        }
        Register.prototype.init = function () {
            Common.checkUserLastActivity();
            var self = this;
            ko.applyBindings(self, document.getElementById("ko-main-content"));
            $("#btn-login-dark").on("click", function (e) {
                $("body").attr("class", "login-layout");
                $("#id-text2").attr("class", "white");
                $("#id-company-text").attr("class", "blue");
                e.preventDefault();
            });
            $("#btn-login-light").on("click", function (e) {
                $("body").attr("class", "login-layout light-login");
                $("#id-text2").attr("class", "grey");
                $("#id-company-text").attr("class", "blue");
                e.preventDefault();
            });
            $("#btn-login-blur").on("click", function (e) {
                $("body").attr("class", "login-layout blur-login");
                $("#id-text2").attr("class", "white");
                $("#id-company-text").attr("class", "light-blue");
                e.preventDefault();
            });
        };
        Register.prototype.register = function () {
            var self = this;
            var obj = ko.mapping.toJS({
                Email: self.Email,
                Password: self.Password,
                ConfirmPassword: self.ConfirmPassword
            });
            obj["__RequestVerificationToken"] = $('input[name="__RequestVerificationToken"]').val();
            var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            if (!regex.test(obj.Email) || !obj.Email) {
                $(".validation-summary-valid ul").html("<li>Please enter a valid email address.</li>");
                return;
            }
            if (!obj.Password) {
                $(".validation-summary-valid ul").html("<li>Please enter a password.</li>");
                return;
            }
            if (obj.Password.length < 6) {
                $(".validation-summary-valid ul").html("<li>The password must be at least 6 characters.</li>");
                return;
            }
            if (obj.Password != obj.ConfirmPassword) {
                $(".validation-summary-valid ul").html("<li>The confirmation password does not match.</li>");
                return;
            }
            $("#submit").prop("disabled", true);
            $("#submit").html('<i class="fa fa-spinner fa-spin"></i> Registering');
            tools.ajaxPost({
                url: "/Account/Register",
                data: obj,
            }).done(function (result) {
                if (result.Data && result.Data.RegisterSuccess) {
                    window.location.href = "RegisterConfirmation";
                }
                else {
                    if (result.Data && result.Data.Error != null) {
                        $(".validation-summary-valid ul li").show();
                        $(".validation-summary-valid ul").html("<li>" + result.Data.Error + "</li>");
                    }
                    $("#submit").prop("disabled", false);
                    $("#submit").html("Register");
                    return;
                }
            });
            return;
        };
        Register.prototype.forgotPassword = function () {
            var self = this;
            var obj = ko.mapping.toJS({
                Email: self.Email,
            });
            obj["__RequestVerificationToken"] = $('input[name="__RequestVerificationToken"]').val();
            var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            if (!regex.test(obj.Email) || !obj.Email) {
                $(".validation-summary-valid ul").html("<li>Please enter a valid email address.</li>");
                return;
            }
            $("#submit").prop("disabled", true);
            $("#submit").html('<i class="fa fa-spinner fa-spin"></i> Sending');
            tools.ajaxPost({
                url: "/Account/ForgotPassword",
                data: obj,
            }).done(function (result) {
                if (result.Data && result.Data.RegisterSuccess) {
                    window.location.href = "RegisterConfirmation";
                }
                else {
                    if (result.Data && result.Data.Error != null) {
                        $(".validation-summary-valid ul li").show();
                        $(".validation-summary-valid ul").html("<li>" + result.Data.Error + "</li>");
                    }
                    $("#submit").prop("disabled", false);
                    $("#submit").html("Send me!");
                    return;
                }
            });
            return;
        };
        return Register;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/Account") && !urls_1.urls.startsWith("/Accounting") && !urls_1.urls.startsWith("/Account/Login") && !urls_1.urls.startsWith("/Account/ResetPassword")
            && !urls_1.urls.startsWith("/Account/Manage") && !urls_1.urls.startsWith("/Account/ViewProfile") && !urls_1.urls.startsWith("/Account/EditProfile")) {
            log.log("Initialize register");
            $(function () {
                (new Register()).init();
            });
        }
    }, 0);
    return Register;
});
//# sourceMappingURL=register.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/register/register.js
// module id = 277
// module chunks = 2